import { useMemo } from 'react'
import { useAuth } from 'user-auth'
import { useMap } from '~map-preview/states/map'

export const useIsShareAllowed = () => {
  const { user } = useAuth()
  const map = useMap()

  const isShareAllowed = useMemo(() => {
    if (!map || !Object.keys(map).length) return false
    if (map.isPublic) return true
    /**
     * this assumes that the user is already an authenticated part of the map's workspace
     * if map is not public, only allow sharing if user is NOT a guest
     * **/
    if (!user) return false

    // temp map doesnt have mapGuestAccessCollection yet
    return (
      'mapGuestAccessCollection' in map &&
      'items' in map.mapGuestAccessCollection &&
      map.mapGuestAccessCollection.items.every(
        (guest) => guest.userId !== user.id
      )
    )
  }, [map, user])

  return isShareAllowed
}
